<template>
    <nav :class="['relative flex flex-col w-full max-w-xl mx-auto p-4 overflow-hidden', getBgColor(alert.heading), getTextColor(alert.heading)]">
        <div class="flex items-center gap-2">
            <svg v-if="alert.heading && alert.heading.toLowerCase() === 'success'" class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clip-rule="evenodd" />
            </svg>
            <svg v-else-if="alert.heading && alert.heading.toLowerCase() === 'alert'" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.25-9.25a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zm-.25 5.75a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/>
            </svg>
            <svg v-else class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" />
            </svg>
            <span class="font-semibold capitalize text-sm">{{ alert.heading }}</span>
        </div>
        <div class="mx-6">
            <p v-html="alert.message" class="text-xs"></p>
        </div>
        <button @click="REMOVE_ALERT(alert)" type="button" class="absolute top-1 right-2 bg-transparent hover:opacity-50 text-2xl p-1 ml-auto inline-flex items-center" data-modal-toggle="authentication-modal">
            &times;
        </button>
   </nav>
</template>
<script>
    import { mapMutations } from 'vuex';

    export default {
        name: 'AlertComponent',
        props: {
            alert: {
                type: Object,
                required: true
            }
        },
        methods: {
                ...mapMutations(['REMOVE_ALERT']),

                getBgColor(heading) {
                    if (!heading) return 'bg-red-200';
                    switch (heading.toLowerCase()) {
                        case 'success':
                            return 'bg-green-200';
                        case 'alert':
                            return 'bg-yellow-200';
                        case 'info':
                            return 'bg-gray-200';
                        default:
                            return 'bg-red-200';
                    }
                },
                getTextColor(heading) {
                    if (!heading) return 'text-red-800';
                    switch (heading.toLowerCase()) {
                        case 'success':
                            return 'text-green-800';
                        case 'alert':
                            return 'text-yellow-800';
                        case 'info':
                            return 'text-black';
                        default:
                            return 'text-red-800';
                    }
                }
            }
    }
</script>